var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import SupplierGoods from './SupplierGoods.vue';
import SupplierShops from './SupplierShops.vue';
import ClientService from '../../api/ClientService';
import { auth } from "../../helper/authDecorator";
import { nameDict } from "../../constant/authCode";
import PhoneInfo from './components/PhoneInfo.vue';
import { mapActions } from 'vuex';
import licesePriview from "./components/LiceseImgPriview.vue";
import DialogTemporaryTokenLogin from '@/components/DialogTemporaryTokenLogin.vue';
import CustomerGoodsAliasTable from './components/CustomerGoodsAliasTable.vue';
var Detail = (function (_super) {
    __extends(Detail, _super);
    function Detail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeName = '1';
        _this.clientId = null;
        _this.supplierToBusinessId = null;
        _this.isShowSalesMan = false;
        _this.formData = {
            business_name: "",
            business_cooperation_state: "",
            accountdatetype: "",
            business_contact: "",
            business_phone: "",
            business_address: "",
            business_level_name: ""
        };
        _this.from_system = '1';
        _this.clientDetail = {
            supplier_to_business_id: ''
        };
        _this.document_pic = [];
        _this.isOpenApAccountTypeBusiness = false;
        return _this;
    }
    Detail.prototype.created = function () {
        this.service = ClientService.getInstance();
    };
    Detail.prototype.initInfo = function () {
        var _this = this;
        var params = {
            business_id: this.clientId,
            supplier_to_business_id: this.supplierToBusinessId
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.getcertificate();
        this.service.getDetail(params).then(function (res) {
            if (res.data.success) {
                _this.formData = res.data.data;
                _this.clientDetail = res.data.data;
                _this.isOpenApAccountTypeBusiness = res.data.is_open_ap_account_type_business;
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    Detail.prototype.mounted = function () {
        this.initInfo();
        this.initReportAuth();
    };
    Detail.prototype.initReportAuth = function () {
        var _this = this;
        this.getAuth('210013').then(function (pageAuth) {
            _this.isShowSalesMan = pageAuth.Auth.LookDetail;
        });
    };
    Detail.prototype.showPhoneInfo = function () {
        var _this = this;
        var dialog = this.$dialog(PhoneInfo, {
            phone: this.clientDetail.shopping_info.account_info.phone,
            business_id: this.clientId,
            supplier_to_business_id: this.supplierToBusinessId,
            is_freeze: this.clientDetail.shopping_info.freeze_shopping
        }, {
            title: "修改客户外销账号",
            closeBtn: false,
            height: 300,
            width: 500
        });
        dialog.instance.$on("save:ok", function (res) {
            _this.initInfo();
        });
    };
    Detail.prototype.openTemporaryTokenLoginDialog = function () {
        var instance = this.$dialog(DialogTemporaryTokenLogin, {
            data: {
                business_id: this.clientId,
            }
        }, {
            title: "登录客户外销商城",
            width: 400,
            height: 400,
            zIndex: 1002,
        }).instance;
    };
    Detail.prototype.getcertificate = function () {
        var _this = this;
        var params = {
            business_id: this.clientId,
            supplier_to_business_id: this.supplierToBusinessId
        };
        this.service.getCertificate(params).then(function (res) {
            _this.document_pic = Array.isArray(res.data.data.customer_certificates) ? res.data.data.customer_certificates : [];
            var newData = [];
            _this.document_pic.forEach(function (item, index) {
                newData.push({
                    url: item,
                });
            });
            _this.document_pic = newData;
        });
    };
    Detail.prototype.priviewImgBtn = function () {
        var instance = this.$dialog(licesePriview, {
            data: {
                document_pic: this.document_pic
            }
        }, {
            title: "单据图片",
            width: 810,
            height: 620
        }).instance;
        instance.$on("editClient:ok", function () {
        });
    };
    Detail = __decorate([
        auth(nameDict["合作客户"]),
        Component({
            components: {
                'supplier-shops': SupplierShops,
                'supplier-goods': SupplierGoods,
                'customer-goods-alias-table': CustomerGoodsAliasTable
            },
            methods: __assign({}, mapActions(["getAuth"]))
        })
    ], Detail);
    return Detail;
}(Vue));
export default Detail;
